import styled from 'styled-components'
import { SPACING, MEDIA } from '../../styles/theme'

export const DashboardContainer = styled.div`
  width: 100%;
  padding: ${SPACING.lg} ${SPACING.md};
  max-width: 1200px;
  margin: 0 auto;

  ${MEDIA.mobile} {
    padding: ${SPACING.lg} ${SPACING.sm};
  }
`
